var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isPC)?_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":"/","width":"700","height":"100%","frameborder":"0"}})]):_c('div',[_c('router-view'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }